import { render, staticRenderFns } from "./HIS4.vue?vue&type=template&id=62295743&scoped=true&"
import script from "./HIS4.vue?vue&type=script&lang=js&"
export * from "./HIS4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62295743",
  null
  
)

export default component.exports